<app-autocomplete-field
  [label]="label()"
  [placeholder]="placeholder()"
  [errorMessage]="errorMessage()"
  [required]="required()"
  [hideRequiredInfo]="hideRequiredInfo()"
  [helperText]="helperText()"
  [suggestions]="filteredCountries()"
  [optionLabel]="'name'"
  [ariaLabel]="'Country'"
  [showSearchIcon]="true"
  [showCaretIcon]="true"
  [showClear]="false"
  (search)="onSearch($event)"
  (optionSelect)="onSelect($event)"
  (clear)="onClear()"
  (hasNoValue)="hasNoValue.emit($event)"
>
  <ng-template #itemTemplate let-item>
    <span [class.country-item--has-separator]="item.hasSeparatorAfter">{{ item.name }}</span>
  </ng-template>
</app-autocomplete-field>
